import React from 'react';
import PropTypes from 'prop-types';

import RestrictedInput from 'ati-ui-react/components/RestrictedInput';
import Skeleton from 'ati-ui-react/components/Skeleton';

import { inputRestriction } from 'ati-utils/consts';
import styles from './styles.modules.scss';

const CoefficientInput = ({placeholder, ratingParamsIsLoading, savedValue, title, value, onBlur, onChange}) => {
    const showAsDiff = savedValue && value && parseFloat(savedValue) !== parseFloat(value);
    const showAsFilled = !ratingParamsIsLoading && savedValue;

    return (
        <div>
            <div className={styles['title']}>
                <div className={styles['title-name']}>
                    {title}
                </div>
                <div className={showAsFilled ? styles['filled'] : undefined}>
                    {ratingParamsIsLoading ?
                        (
                            <Skeleton
                                borderRadius={2}
                                height={10}
                                width={25}
                            />
                        ) : (
                            <span className={showAsDiff ? styles['diff'] : undefined}>
                                {savedValue?.toString() ?? '--'}
                            </span>
                        )}
                </div>
            </div>
            <RestrictedInput
                inputRestriction={inputRestriction.nonNegativeFloat}
                maxLength={10}
                placeholder={placeholder}
                type="text"
                value={value}
                onBlur={onBlur}
                onChange={onChange}
            />
        </div>
    );
};

export default CoefficientInput;

CoefficientInput.propTypes = {
    placeholder: PropTypes.string,
    ratingParamsIsLoading: PropTypes.bool,
    savedValue: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};
